import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  
  constructor() { }
  
  /**
   * Validates an email address format
   * @param email The email address to validate
   * @returns boolean indicating if the email is valid
   */
  validateEmail(email: string): boolean {
    if (!email) return false;
    
    // RFC 5322 compliant email regex
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email.trim());
  }
  
  /**
   * Validates multiple email addresses
   * @param emails Array of email addresses to validate
   * @returns Object with validation results for each email
   */
  validateEmails(emails: string[]): { [key: string]: boolean } {
    const results: { [key: string]: boolean } = {};
    
    emails.forEach(email => {
      if (email) {
        results[email] = this.validateEmail(email);
      }
    });
    
    return results;
  }
}